import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { makeStyles } from "@material-ui/core/styles";

import GridItem from "../Grid/GridItem";
import {
  blackColor,
  grayColor,
  hexToRgb,
} from "../../assets/jss/material-dashboard-pro-react";

const styles = {
  actionWrapperOuter: {
    paddingLeft: "10px !important",
    paddingRight: "10px !important",
  },
  actionWrapper: {
    cursor: "pointer",
    opacity: "0.8",
    transition: "opacity 0.1s",
    "&:hover,&:active": {
      opacity: "1",
      "& div:first-child": {
        boxShadow: "0 0px 30px -10px rgba(" + hexToRgb(blackColor) + ", 0.3)",
      },
      "& div:first-child > svg": {
        transform: "scale(1.2)",
      },
    },
    "&:active": {
      "& div:first-child": {
        boxShadow:
          "0 0px 30px -10px rgba(" + hexToRgb(blackColor) + ", 0.7) !important",
      },
    },
  },
  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },
  actionIcon: {
    color: grayColor[6],
    margin: "6px auto 0",
    width: "42px",
    height: "42px",
    border: "1px solid " + grayColor[11],
    borderRadius: "50%",
    textAlign: "center",
    lineHeight: "58px",
    transition: "box-shadow 0.2s",
    "& svg": {
      marginLeft: "1px",
      transition: "transform 0.2s",
      width: "26px",
      height: "26px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "26px",
      fontSize: "26px",
    },
  },
  actionText: {
    color: grayColor[0],
    marginTop: "6px",
    marginBottom: "2px",
    textAlign: "center",
    fontSize: "10px",
  },
};

const useStyles = makeStyles(styles);

export default function ActionBarButton(props) {
  const { icon, text, onClickHandler, disabled } = props;
  const classes = useStyles();
  return (
    <GridItem className={classes.actionWrapperOuter} onClick={onClickHandler}>
      <div
        className={cx({
          [classes.actionWrapper]: true,
          [classes.actionDisabled]: disabled,
        })}
      >
        <div className={classes.actionIcon}>{icon}</div>
        <h6 className={classes.actionText}>{text}</h6>
      </div>
    </GridItem>
  );
}

ActionBarButton.propTypes = {
  icon: PropTypes.element.isRequired,
  text: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
};
